import React, { useEffect, useState } from "react";
import { downloadExcel } from "../../../helpers/Common";
import { Modal } from "react-bootstrap";
import moment from "moment";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { Button } from "reactstrap";
import { ApiGet } from "../../../helpers/API/ApiData";
import { toast } from "react-toastify";
import "./Berichtherunterladenmodal.scss";
import useDebounce from "../../../hooks/useDebounceHook";

function DownloadFilterModel({ id, donwloadModel, setDonwloadModel, handleCloseDownloadModel, handleOnChange, handleChangeAssign }) {
  const [locationNames, setLocationNames] = useState([]);
  const [searchLoaction, setSearchLoaction] = useState();
  const [locationLoader, setLocationLoader] = useState(false);
  const debouncedSearchLocation = useDebounce(searchLoaction, 900);

  const isAssignViolateOption = [
    {
      value: "",
      label: "Alle",
    },
    {
      value: true,
      label: "verletzen",
    },
    {
      value: false,
      label: "nicht flüchtig",
    },
  ];

  const handleDownloadReport = async () => {
    setDonwloadModel({ ...donwloadModel, loading: true });

    try {
      const response = await ApiGet(
        `dahualocation/getLocationEvents?download=true${id ? `&locationId=${id}` : ""}${donwloadModel?.locationId ? `&locationId=${donwloadModel?.locationId?.value}` : ""}${
          donwloadModel?.violateOption?.value ? `&isViolation=${donwloadModel?.violateOption?.value}` : ""
        }${donwloadModel?.startDate ? `&startDate=${moment(donwloadModel?.startDate).format("YYYY-MM-DD")}` : ""}${donwloadModel?.endDate ? `&endDate=${moment(donwloadModel?.endDate).format("YYYY-MM-DD")}` : ""}`
      );
      downloadExcel(response?.data);
      setDonwloadModel({
        isOpen: false,
        startDate: null,
        endDate: null,
        violateOption: null,
        loading: false,
      });
    } catch (error) {
      if (error?.response?.status === 404) {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error(error);
        setDonwloadModel({
          isOpen: false,
          startDate: null,
          endDate: null,
          violateOption: null,
          loading: false,
        });
      }
    }
  };

  const handleGetSalesPatner = async () => {
    setLocationLoader(true);
    try {
      const response = await ApiGet(`dahualocation/getAllLocations?limit=${10}&page=${1}${debouncedSearchLocation ? `&search=${searchLoaction}` : ""}`);
      const data = response?.data?.payload;
      if (data && Array.isArray(data)) {
        const optionData = data.map((item) => ({
          value: item?._id,
          label: item?.name,
        }));

        setLocationNames(optionData);
        setLocationLoader(false);
      }
    } catch (error) {
      if (error?.response?.status === 404) {
        setLocationNames([]);
        setLocationLoader(false);
      } else {
        setLocationLoader(false);
        toast.error("Etwas ist schief gelaufen");
      }
    }
  };

  useEffect(() => {
    handleGetSalesPatner();
  }, [debouncedSearchLocation]);

  return (
    <Modal show={donwloadModel?.isOpen} onHide={handleCloseDownloadModel} className="d-flex justify-content-center align-items-center addplatesmodalmainalignment">
      <div className="modal-content new-model-conent-sye" style={{ minHeight: "400px", overflow: "auto" }}>
        <Modal.Header className="justify-content-start d-flex align-items-center" closeButton>
          <Modal.Title style={{ color: "#D7365A" }}>Bericht herunterladen </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "fit-content", overflow: "unset" }}>
          <div className="Bericht-herunterladen-modal-body-alignment">
            <div className={` reactDatePicker`}>
              <DatePicker
                selected={donwloadModel?.startDate}
                startDate={donwloadModel?.startDate}
                endDate={donwloadModel?.endDate}
                dateFormat="dd/MM/yyyy"
                placeholderText="Datum"
                maxDate={new Date()}
                onChange={(e) => handleOnChange(e, "forDownload")}
                onKeyDown={(e) => e.preventDefault()}
                selectsRange
                // fixedHeight
              />
            </div>

            <div className="project-Dropdown project-Dropdown-sc">
              <Select
                className="Select-main"
                // menuIsOpen={true}
                value={donwloadModel?.violateOption}
                name="isAssign"
                onChange={(e) => handleChangeAssign(e, "forDownload")}
                options={isAssignViolateOption}
                // styles={ProjectStyle}
                defaultValue={donwloadModel?.violateOption}
                placeholder="Abstrafungen"
                isClearable={true}
              />
            </div>

            {!id && (
              <div className="header-items">
                <div className="project-Dropdown  project-Dropdown-sc">
                  <Select
                    className="Select-main"
                    value={donwloadModel?.locationId}
                    name="location"
                    onChange={(e) => handleChangeAssign(e, "downloadLocation")}
                    options={locationNames}
                    //   styles={ProjectStyle}
                    defaultValue={donwloadModel?.locationId}
                    placeholder="Standorte"
                    isClearable={true}
                    onInputChange={(value) => setSearchLoaction(value)}
                  />
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="activebutton h-40px" onClick={handleCloseDownloadModel} style={{ marginRight: "15px" }}>
            Schließen
          </Button>
          <Button className="addbutton h-40px" onClick={handleDownloadReport} style={{ marginRight: "15px" }}>
            Herunterladen
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
}

export default DownloadFilterModel;
